import { createFileRoute } from "@tanstack/react-router";
import { SamarbejdspartnerePage, samarbejdspartnereHead } from "@/pages/SamarbejdspartnerePage";

export const Route = createFileRoute("/samarbejdspartnere")({
  head: () => samarbejdspartnereHead("da"),
  component: () => <SamarbejdspartnerePage locale="da" />,
});
